module.exports = __webpack_public_path__ + "static/media/26.66673f3d.jpg";